import React, { useEffect, useState } from "react";
import {
  Modal, Box, TextField, Typography, MenuItem,
  Button, Grid, Card, CardMedia, IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%", left: "50%",
  transform: "translate(-50%, -50%)",
  width: '80vw', // Ensure enough horizontal space
  maxWidth: 1000, // Optional: limit max modal width
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const AddCategoryModal = ({ open, isEditMode, handleClose, handleAddSubmitBt, selectedEmptyItem, selectedEditItem, modifiedGenersData }) => {

  //console.log("selectedEmptyItem",selectedEmptyItem);
  //console.log("selectedEditItem",selectedEditItem);
  //console.log("isEditMode",isEditMode);

  const initialFormData = {
    id: "",
    type: "",
    title: "",
    "sub-title": "",
    description: "",
    image: "",
    status: "",
    children_type: "",
    children: []
  };


  const [formData, setFormData] = useState(initialFormData);
  const [imageFile, setImageFile] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    console.log("isEditMode : ",isEditMode)
    console.log("selectedEditItem : ",selectedEditItem)
    if (isEditMode && selectedEditItem) {
      setFormData(selectedEditItem);
    } else if (!isEditMode) {
      setFormData(initialFormData);
    }

  }, [isEditMode, selectedEditItem]);

  //console.log("formData",formData);

  const childTypeOptionsAll = [
    { value: "gener", label: "Gener" },
    { value: "trivia_category", label: "Trivia Category" },
    { value: "trivia_sub_category", label: "Trivia Sub Category" },
    { value: "show", label: "show" },
  ];

  const childTypeOptionsGener = [
    { value: "trivia_category", label: "Trivia Category" },
    { value: "show", label: "show" },
  ];

  const childTypeOptionsTriviaCategory = [
    { value: "trivia_sub_category", label: "Trivia Sub Category" },
    //{ value: "show", label: "show" },
  ];

  const getDropDownValues = () => {
    //console.log(selectedEmptyItem?.children_type)
    if (selectedEmptyItem || selectedEditItem) {
      if ((selectedEmptyItem?.children_type || selectedEditItem?.children_type) === 'gener') {
        return childTypeOptionsGener;
      }
      else if ((selectedEmptyItem?.children_type || selectedEditItem?.children_type) === 'trivia_category') {
        return childTypeOptionsTriviaCategory;
      }
      else {
        return;
      }
    }
    else {
      return childTypeOptionsGener;
    }
  }

  const isFormEmpty = Object.values(formData).every(
    (value) => value === null || value === ""
  );

  const isFormValid = () => {
    const hasDropDown = getDropDownValues();
    const isValidate = (
      formData?.title?.trim() !== "" &&
      formData?.["sub-title"]?.trim() !== "" &&
      formData?.description?.trim() !== "" &&
      formData?.image?.trim() !== "" &&
      (!isEditMode ? (!hasDropDown || formData?.childType?.trim() !== "") : true)
    );
    //console.log("isValidate : ",isValidate)
    //console.log("field : ", formData?.childType?.trim())
    return isValidate;
  };

  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
    setErrors({ ...errors, [field]: "" });
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    setImageFile(file);
    setFormData({ ...formData, image: URL.createObjectURL(file) });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData["sub-title"]) newErrors.subTitle = "Subtitle is required";
    if (!formData.description) newErrors.description = "Description is required";
    if (!formData.image) newErrors.image = "Image is required";
    if (!isEditMode || getDropDownValues()) {
      if (!formData.children_type) newErrors.children_type = "Child Type is required";
    }
    setErrors(newErrors);
    console.log(newErrors)
    return Object.keys(newErrors).length === 0;
  };

  const createID = () => {
    if (!selectedEmptyItem || selectedEmptyItem?.children_type === 'gener') {
      return 'g_';
    }
    else if (selectedEmptyItem?.children_type === 'trivia_category') {
      return 'tc_';
    }
    else if (selectedEmptyItem?.children_type === 'trivia_sub_category') {
      return 'tsc_';
    }
    else if (selectedEmptyItem?.children_type === 'show') {
      return 'sh_';
    }
  }

  const handleSubmit = () => {
    if (validate()) {
      console.log("Submitted data:", formData);
      if (!isEditMode) {
        const newItem = {
          'id': isEditMode ? formData?.id : createID(),
          'title': formData?.title,
          'sub-title': formData?.["sub-title"],
          'description': formData?.description,
          'image': formData?.image,
          'type': formData?.type,

        }
        if (formData?.children_type) {
          const newItemWithChildrenType = { ...newItem, 'children_type': formData?.children_type }
          handleAddSubmitBt(newItemWithChildrenType);
        }
        else {
          handleAddSubmitBt(newItem);
        }
      }
      else {
        console.log("add : ", formData)
        handleAddSubmitBt(formData);
      }
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <IconButton onClick={() => {
          setFormData(initialFormData);
          handleClose();
        }} sx={{ position: "absolute", top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" mb={3}>{isEditMode ? 'Edit' : 'Add'} New Category</Typography>

        <Grid container spacing={4} alignItems="flex-start" sx={{ justifyContent: 'center', width: '100%' }} >

          <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TextField
              fullWidth
              required
              label="Title"
              value={formData.title}
              onChange={handleChange("title")}
              error={!!errors.title}
              helperText={errors.title}
              margin="dense"
            />
            <TextField
              fullWidth
              required
              label="Subtitle"
              value={formData["sub-title"]}
              onChange={handleChange("sub-title")}
              error={!!errors["sub-title"]}
              helperText={errors["sub-title"]}
              margin="dense"
            />
            <TextField
              fullWidth
              required
              label="Description"
              value={formData.description}
              onChange={handleChange("description")}
              error={!!errors.description}
              helperText={errors.description}
              margin="dense"
              multiline
              rows={3}
            />
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              marginTop: 1
            }}>
              <TextField
                fullWidth
                required
                label="Image URL"
                name="image"
                value={formData.image}
                onChange={handleChange}
                error={!!errors.image}
                helperText={errors.image}
              />
              <Button
                variant="contained"
                component="label"
                sx={{
                  whiteSpace: 'nowrap',
                  height: '48px'
                }} // match TextField height
              >
                Upload
                <input type="file" hidden onChange={handleImageUpload} />
              </Button>
            </Box>
            {(!isEditMode && getDropDownValues()) ? (<TextField
              select
              fullWidth
              required
              label="Child Type"
              value={formData.children_type}
              onChange={handleChange("children_type")}
              error={!!errors.children_type}
              helperText={errors.children_type}
              margin="dense"
              sx={{ mt: 2 }}
            >
              {getDropDownValues()?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>) : (null)}
            <Button
              variant="contained"
              fullWidth
              sx={{ height: "50px", mt: 2 }}
              onClick={handleSubmit}
              disabled={!isFormValid()}
            >
              Submit
            </Button>
          </Grid>

          {/* Live Preview */}
          {!isFormEmpty && <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ width: '100%' }}>
              <Typography variant="subtitle1" mb={1}>Live Preview</Typography>
              <Card sx={{ borderRadius: 3, overflow: "hidden", height: 200, position: "relative" }}>
                {formData.image && (
                  <CardMedia
                    component="img"
                    height="200"
                    image={formData.image}
                    alt={formData.title}
                    sx={{ objectFit: "cover" }}
                  />
                )}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: "rgba(0,0,0,0.5)",
                    color: "#fff",
                    p: 1,
                  }}
                >
                  <Typography variant="subtitle1">{formData.title || "Title"}</Typography>
                  <Typography variant="body2">{formData.subTitle || "Subtitle"}</Typography>
                </Box>
              </Card>
            </Box>
          </Grid>}

        </Grid>
      </Box>
    </Modal>
  );
};

export default AddCategoryModal;
